module.exports = __webpack_public_path__ + "img/value-props-assortment-1.bafe6127.jpg";